import * as moment from 'moment';
const initialState = {
  data: [
    {
      location: 'Barcelona',
      description: "Change the Way we Shop",
      date: moment('14/04/2018', 'DD/MM/YYYY'),
      bannerImage: '/img/header-image-2.png',
      bannerImage2: '/img/header-image-1.png',
      locationCoords:{lat: 41.3977391, lng: 2.1881113},

      noteDescription: 'Do you have what it takes to get to the finals at adidas HQ in Herzogenaurach on July, the 2nd -July, the 3rd 2018? First step – win your local hackathon!',

      fullDescription: 'Consumers are at the heart of everything we do. Latest technologies, our passion. Join us in our Hackathon to create the new digital shopping experience. More details will be announced shortly before and during the hackathon.',

      fromToDate: '14-15.04.2018',

      techLibraryDesc: "We will provide you with different technologies like NFC readers/writers, tags, beacons, sensors, cardboards and more. You will have the chance to learn from the most experienced engineers about different technologies like machine learning, big data and others. Additionally, we will provide you with the APIs and datasets for building your solution. Stay tuned for more info.",
      techs: [
        {
          name:'Tech 1',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 2',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 3',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 4',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        }
      ],
      venueNameTitle: 'Iron Hack',
      venueName: 'Carrer de Pamplona, 96, 08018 Barcelona, Spain',
      mapImage: 'http://www.abc.es/media/espana/2017/10/11/plazaesp-kKrD--620x349@abc.jpg',
      judges: [
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },{
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
      ],
      prizes: 'The winning team from Barcelona will qualify for the final at adidas global HQ in Germany where they will compete with the 3 other winners to become the global champion and win exclusive awards. All 4 teams will experience the 3-stripe culture and have the chance to pitch their concept to our senior IT leaders. The winner will receive an exclusive grand prize package. Additionally, there will be prizes for the local winners worth up to 10K in local currency.',

      applicationProcess: 'Apply with your team or alone. adidas will select on rolling basis. The quicker you are, the more chance you have to get in. If you register with a team- you need to add the names of your teammates and they will get an invitation to register. If you join without a team you will have the chance to create your own team, join another one on Slack before or during the hackathon. The ones that get in will receive access to our channel in Slack where they can start building their team and brainstorming ideas. Please note – due to the highly international adidas teams & guests, the hackathons will be held mainly in English. We will have people speaking the local language but the presentations and the final prototypes/projects pitches have to be in English.',

      travelReimbursement: 'adidas is offering a limited number of travel reimbursements (worth up to 50€ per person) for the first participants to request, coming from somewhere outside of the city where the hackathon is happening. If you get accepted, you need to be quick in applying for reimbursement. In the confirmation e-mail you will receive more information of how to apply. If you win your local hackathon, you will be offered a fully sponsored trip to adidas HQ in Germany. Please check the FAQ for more details.',


      adidasTeam:[
        {
          name:'GERARDO GÓMEZ',
          position: 'DIRECTOR SOFTWARE ENGINEERING',
          info:'I grew up with Symbian (Nokia), bought the very first iPhone when living in the US, attended the first conference from Google about a new language called android, and since then I\'ve been addicted to everything related to mobile and AI. It does not mean I\'m old, it s just that I started too early on this. Road cycling, basketball, and running are my hobbies in my spare time.',
          photo: '/img/adidas-team-barcelona/Gerardo_Gomez.jpg'
        },
        {
          name:'JAVIER FRECHOSO',
          position: 'SOFTWARE ENGINEER',
          info:'I joined adidas 2 years ago as a dev leader in software engineering team. I have been working for 15 years in web development projects. I am interested e-commerce platforms, agile methodologies, Java and JavaScript programming languages. I love traveling and sports!',
          photo: '/img/adidas-team-barcelona/Javier_Frechoso.jpg'
        },
        {
          name:'IGNACIO MUÑOZ',
          position: 'SOFTWARE ENGINEER',
          info:'You can call me Nacho, I have been working in mobile technologies for a long, long time. I develop in Android, iOS, Hybrid apps, and also web (PWA) with SPA frameworks based in JavaScript like Angular. Now I\'m playing with CI/CD (DevOps) also.',
          photo: '/img/adidas-team-barcelona/Nacho_Munoz.jpg'
        },
        {
          name:'RAFAEL MARCÉN',
          position: 'MOBILE DEVELOPER',
          info:'I joined adidas after I took part in last year’s adidas hackathon in Zaragoza. The experience was so meaningful and awesome! I\'ve been working as a mobile developer and I love technologies related to AR and VR. I like all kind of sports, although football and motorsport are my bread and butter.',
          photo: '/img/adidas-team-barcelona/Rafa_Marcen.jpg'
        },
        {
          name:'YONEL ILIEVA',
          position: 'PRODUCT MANAGER, DIGITAL PERSONALIZATION, IT',
          info:'My role crosses the intersection where technology meets business. Java, data models, APIs help me bring the business vision into technical capabilities. Together with my team, we shape the roadmap for our digital product, constantly exploring cutting-edge technologies. I am passionate about AI, data and their utilization in sport & digital products.',
          photo: '/img/adidas-team-barcelona/Yonel_Ilieva.jpg'
        },
        {
          name:'JORGE CHATO',
          position: 'SOFTWARE ENGINEER',
          info:'Born in Spain and bred in the internet. Hacker, free culture, and AI lover. My name is Jorge and coding is the sauce of my life.',
          photo: '/img/adidas-team-barcelona/Jorge_Chato.jpg'
        },
        {
          name:'ISABEL AGUSTÍN',
          position: 'SOFTWARE ENGINEER',
          info:'Hi, I am Isabel and I\'d been working on test automation for a year before I joined to adidas. I like sports, especially outdoor sports and mountain biking.',
          photo: '/img/adidas-team-barcelona/Isabel_Agustin.jpg'
        },
        {
          name:'JORGE CÁNCER',
          position: 'SOFTWARE ENGINEER',
          info:'I\'ve been working to build microservices here at adidas for the past 7 months. I participated in many hackathons before deciding to run my own. I love motorsports, especially Formula 1 and everything about it. I played handball for 3 years.',
          photo: '/img/adidas-team-barcelona/Jorge_Cancer.jpg'
        },
        {
          name:'ALEJANDRO LATORRE',
          position: 'SOFTWARE DEVELOPER',
          info:'I\'m 26 and I\'ve been working with different technologies related to operations and monitoring. I love football and support my local team, Real Zaragoza. :D',
          photo: '/img/adidas-team-barcelona/Alejandro_Latorre.jpg'
        },
        {
          name:'FERNANDO LUIS ALIAGA',
          position: 'SOFTWARE DEVELOPER',
          info:'I\'m 26 and I\'ve been working in Mobile technology, developing, and now as DevOps. I love technologies, especially AR and ML, music, and sports.',
          photo: '/img/adidas-team-barcelona/Fernando_Aliaga.jpg'
        },
        {
          name:'LAURA DUATO',
          position: 'SOFTWARE ENGINEER',
          info:'I\'ve been working with iOS applications since I did my final project at university in 2011. I like sports and my favorite one is tennis.',
          photo: '/img/adidas-team-barcelona/Laura_Duato.jpg'
        },
        {
          name:'ANTONIO MARTÍNEZ',
          position: 'SOFTWARE DEVELOPER',
          info:'Born and raised in Zaragoza. I automate tasks as much as I can. My interests include data and AI, but while in adidas I\'ve found a new passion - DevOps. My favorite sports are running, skiing, football, and basketball.',
          photo: '/img/adidas-team-barcelona/Antonio_Martinez.jpg'
        },
        {
          name:'CARMEN JIMÉNEZ',
          position: 'TALENT ACQUISITION',
          info:'I\'m part of the Talent Acquisition Team. I consider myself as a positive, curious, and creative person. Passionate about my job, I always look for the best talent for our IT teams.',
          photo: '/img/adidas-team-barcelona/Carmen_Jimenez.jpg'
        },
        {
          name:'BILAL ÇINARLI',
          position: 'SOFTWARE ENGINEER',
          info:'I\'m working for adidas and a Google Developer Expert on Web Technologies. I\'m a big enthusiast of building maintainable and scalable front-ends. To achieve this goal, I maintain open-source projects such as Caffeine, Melange, and UX Rocket. I speak at conferences and give workshops about JavaScript, Frontend Architecture and CSS.',
          photo: '/img/adidas-team-barcelona/Bilal_Cinarli.jpg'
        },
        {
          name:'IRIS DAGCI',
          position: 'RECRUITER DIGITAL IT, DBC',
          info:'As a recruiter for Digital Brand Commerce and Digital IT based at our HQ in Germany I\'m always curious about new digital trends and technologies. Looking forward to the Barcelona Hackathon, meeting new people and exchanging ideas.',
          photo: '/img/adidas-team-barcelona/Iris_Dagci.jpg'
        }
      ],

      collaborators:[
        {
          collaboratorName: 'inflojobs',
          collaboratorLogo: '/img/logo-inflojobs.jpg',
          collaboratorLink: 'https://adidas.trabajo.infojobs.net/adidas-digital'
        }
      ],

      locationVideo:[
        {
          videoId: 'dWVhJ-j0894'
        }
      ],

      photosSlider:[
        {
          imgSlide1:'/img/photos-barcelona/slide-4.jpg',
          imgSlide2:'/img/photos-barcelona/slide-6.jpg',
          imgSlide3:'/img/photos-barcelona/slide-8.jpg',
          imgSlide4:'/img/photos-barcelona/slide-9.jpg',
          imgSlide5:'/img/photos-barcelona/slide-10.jpg',
          imgSlide6:'/img/photos-barcelona/slide-11.jpg',
          imgSlide7:'/img/photos-barcelona/slide-12.jpg',
          imgSlide8:'/img/photos-barcelona/slide-13.jpg',
          imgSlide9:'/img/photos-barcelona/slide-15.jpg',
          imgSlide10:'/img/photos-barcelona/slide-16.jpg',
          imgSlide11:'/img/photos-barcelona/slide-17.jpg',
          imgSlide12:'/img/photos-barcelona/slide-18.jpg',
          imgSlide13:'/img/photos-barcelona/slide-19.jpg',
          imgSlide14:'/img/photos-barcelona/slide-20.jpg',
          imgSlide15:'/img/photos-barcelona/slide-21.jpg',
          imgSlide16:'/img/photos-barcelona/slide-22.jpg',
          imgSlide17:'/img/photos-barcelona/slide-23.jpg',
          imgSlide18:'/img/photos-barcelona/slide-24.jpg',
          imgSlide19:'/img/photos-barcelona/slide-26.jpg',
          imgSlide20:'/img/photos-barcelona/slide-28.jpg',
          imgSlide21:'/img/photos-barcelona/slide-30.jpg',
          imgSlide22:'/img/photos-barcelona/slide-32.jpg',
          imgSlide23:'/img/photos-barcelona/slide-33.jpg',
          imgSlide24:'/img/photos-barcelona/slide-34.jpg',
          imgSlide25:'/img/photos-barcelona/slide-35.jpg',
          imgSlide26:'/img/photos-barcelona/slide-36.jpg',
          imgSlide27:'/img/photos-barcelona/slide-37.jpg',
          imgSlide28:'/img/photos-barcelona/slide-38.jpg',
          imgSlide29:'/img/photos-barcelona/slide-39.jpg',
          imgSlide30:'/img/photos-barcelona/slide-40.jpg',
          imgSlide31:'/img/photos-barcelona/slide-41.jpg',
          imgSlide32:'/img/photos-barcelona/slide-42.jpg',
          imgSlide33:'/img/photos-barcelona/slide-43.jpg',
          imgSlide34:'/img/photos-barcelona/slide-44.jpg',
          imgSlide35:'/img/photos-barcelona/slide-45.jpg',
          imgSlide36:'/img/photos-barcelona/slide-47.jpg',
          imgSlide37:'/img/photos-barcelona/slide-48.jpg',
          imgSlide38:'/img/photos-barcelona/slide-49.jpg',
          imgSlide39:'/img/photos-barcelona/slide-50.jpg',
          imgSlide40:'/img/photos-barcelona/slide-51.jpg',
          imgSlide41:'/img/photos-barcelona/slide-52.jpg',
          imgSlide42:'/img/photos-barcelona/slide-53.jpg',
          imgSlide43:'/img/photos-barcelona/slide-55.jpg',
          imgSlide44:'/img/photos-barcelona/slide-56.jpg',
          imgSlide45:'/img/photos-barcelona/slide-57.jpg',
          imgSlide46:'/img/photos-barcelona/slide-58.jpg',
          imgSlide47:'/img/photos-barcelona/slide-59.jpg',
          imgSlide48:'/img/photos-barcelona/slide-60.jpg',
          imgSlide49:'/img/photos-barcelona/slide-61.jpg',
          imgSlide50:'/img/photos-barcelona/slide-62.jpg',
          imgSlide51:'/img/photos-barcelona/slide-63.jpg',
          imgSlide52:'/img/photos-barcelona/slide-64.jpg',
          imgSlide53:'/img/photos-barcelona/slide-65.jpg',
          imgSlide54:'/img/photos-barcelona/slide-66.jpg',
          imgSlide55:'/img/photos-barcelona/slide-67.jpg',
          imgSlide56:'/img/photos-barcelona/slide-69.jpg',
          imgSlide57:'/img/photos-barcelona/slide-70.jpg',
          imgSlide58:'/img/photos-barcelona/slide-71.jpg',
          imgSlide59:'/img/photos-barcelona/slide-73.jpg',
          imgSlide60:'/img/photos-barcelona/slide-74.jpg',
          imgSlide61:'/img/photos-barcelona/slide-75.jpg',
          imgSlide62:'/img/photos-barcelona/slide-76.jpg',
          imgSlide63:'/img/photos-barcelona/slide-77.jpg',
          imgSlide64:'/img/photos-barcelona/slide-78.jpg',
          imgSlide65:'/img/photos-barcelona/slide-79.jpg',
          imgSlide66:'/img/photos-barcelona/slide-80.jpg',
          imgSlide67:'/img/photos-barcelona/slide-81.jpg',
          imgSlide68:'/img/photos-barcelona/slide-82.jpg',
          imgSlide69:'/img/photos-barcelona/slide-83.jpg',
          imgSlide70:'/img/photos-barcelona/slide-84.jpg'
        }
      ],

      program: {
        '14.04': [
          {
            time: '09:00',
            text: 'Registration & welcome bites'
          },
          {
            time: '10:00',
            text: 'Welcome presentation'
          },
          {
            time: '11:00',
            text: 'Challenge details & tech trainings'
          },
          {
            time: '12:00',
            text: 'Hacking starts'
          },
          {
            time: '14:00',
            text: 'Lunch'
          },
          {
            time: '21:00',
            text: 'Dinner'
          },
        ],

        '15.04': [
          {
            time: '09:00',
            text: 'Breakfast'
          },
          {
            time: '14:00',
            text: 'Lunch'
          },
          {
            time: '15:00',
            text: 'Presentations of the teams'
          },
          {
            time: '17:00',
            text: 'Award ceremony'
          },
          {
            time: '19:00',
            text: 'End'
          },

          {
            time: '',
            text: 'Delicious food, drinks, snacks and other refreshments will be served throughout. Tech trainings and additional activities will be announced shortly before and during the event itself'
          },
        ],
      },
    },


    {
      location: 'Sofia',
      description: "ENHANCE THE FAN EXPERIENCE THROUGH TECH",
      date: moment('12/05/2018', 'DD/MM/YYYY'),
      bannerImage: '/img/header-image-7.png',
      bannerImage2: '/img/header-image-1.png',
      locationCoords:{lat: 42.6665933, lng: 23.3505734},

      noteDescription:'Do you have what it takes to get to the finals at adidas HQ in Herzogenaurach on July, the 2nd -July, the 3rd 2018?  First step – win your local hackathon!',

      fullDescription: 'Connect the passion of the fans with technology. Engage them in a new way digitally through gamification & personalization and create the future fan experience. The accepted participants will receive more details about the specific tech trainings & challenges shortly before and during the hackathon.',

      fromToDate: '12-13.05.2018',

      techLibraryDesc: "Our talented software engineers on site will support you during the hackathon and provide you with a starter-kit of resources like APIs & valuable tech talks related to the specific challenges. Those will help you to build your solution and create completely new & innovative fan experiences through technology. But you are free to use any technology you feel comfortable with! Stay tuned and bring your willingness to collaborate, learn, have fun and WIN!",
      techs: [
        {
          name:'Tech 1',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 2',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 3',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 4',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        }
      ],

      venueNameTitle: 'Work & Share',
      venueName: 'ul. Tintyava 15-17, 1113 NPZ Dianabad, Sofia, Bulgaria',
      mapImage: 'http://www.abc.es/media/espana/2017/10/11/plazaesp-kKrD--620x349@abc.jpg',

      judges: [
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },{
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
      ],
      prizes: 'The winning team from Sofia will qualify for the final at adidas global HQ in Germany where they will compete with the 3 other winners to become the global champion and win exclusive awards. All 4 teams will experience the 3-stripe culture and have the chance to pitch their concept to our senior IT leaders. The winner will receive an exclusive grand prize package. Additionally, there will be prizes for the local winners worth up to 10K in local currency.',

      applicationProcess: 'Apply with your team or alone. adidas will select on rolling basis. The quicker you are, the more chance you have to get in. If you register with a team- you need to add the names of your teammates and they will get an invitation to register. If you join without a team you will have the chance to create your own team, join another one on our platform before or during the hackathon. The ones that get in will receive access to our platform where they can start building their team and brainstorming ideas. Please note – due to the highly international adidas teams & guests, the hackathons will be held mainly in English. We will have people speaking the local language but the presentations and the final prototypes/projects pitches have to be in English.',

      travelReimbursement: 'adidas is offering a limited number of travel reimbursements (worth up to 50€ per person) for the first participants to request, coming from somewhere outside of the city where the hackathon is happening. If you get accepted, you need to be quick in applying for reimbursement. In the confirmation e-mail you will receive more information of how to apply. If you win your local hackathon, you will be offered a fully sponsored trip to adidas HQ in Germany. Please check the FAQ for more details.',

      specialGuests:[
        {
          name:'KYLE COLUMBUS',
          position: 'PROGRAM LAUNCH MANAGER AT FUTURE TRANSPORTATION, MERCEDES-BENZ RESEARCH & DEVELOPMENT N.A',
          info:'Corporate Intrapreneur, start-up founder, advisor, Stanford guest lecturer and small business builder, Kyle finds himself at the intersection of technology and business development. With over a decade in technology development, specializing in both agile methodology and human centered design, Kyle brings the scrappy elegance of Silicon Valley to his business approach.',
          photo: '/img/special-guests-sofia/Kyle_Columbus.jpg'
        }
      ],

      adidasTeam:[
        {
          name:'JOSE PUYAL',
          position: 'DIRECTOR SOFTWARE ENGINEERING, IT',
          info:'I am passionate about the DevOps movement and Agile methodologies. I work at adidas to build strong and high performing engineering teams. Helping them reduce time to value through delivering high quality software at speed.',
          photo: '/img/adidas-team-sofia/Jose_Maria_Puyal.jpg'
        },
        {
          name:'ANDREAS JAHRSTORFER',
          position: 'DIRECTOR PRODUCT MANAGEMENT AGILE, IT',
          info:'At adidas I am leading a highly engaged team of Product Managers who are defining, together with our Product Owners, the digital tomorrow of adidas. I am very curious about new technologies and opportunities that the digital world is offering to business and private life.',
          photo: '/img/adidas-team-sofia/Andreas_Jahrstorfer.jpg'
        },
        {
          name:'YONEL ILIEVA',
          position: 'PRODUCT MANAGER, DIGITAL PERSONALIZATION, IT',
          info:'My role crosses the intersection where technology meets business. Java, data models, APIs help me bring the business vision into technical capability. Together with my team, we shape the roadmap for our digital product, constantly exploring cutting-edge technologies. I am passionate about AI, data and their utilization in sport & digital products.',
          photo: '/img/adidas-team-sofia/Yonel_Ilieva.jpg'
        },
        {
          name:'PAVLINA PAVLOVA',
          position: 'PRODUCT MANAGER, WEB PERSONALIZATION, IT',
          info:'At adidas I work as a Product Manager in the area of Web and Mobile personalization. I get to combine my knowledge in backend and frontend development and my interest in UX design to support the personalization team in reaching their technical goals. In my free time, I love playing console games and going climbing.',
          photo: '/img/adidas-team-sofia/Pavlina_Pavlova.jpg'
        },
        {
          name:'ALVARO RECUENCO',
          position: 'SOFTWARE DEVELOPER, IT',
          info:'I work as a Software Developer in Consumer Acquisition team. Currently I am designing and developing new APIs based on micro-services architecture. Java and JavaScript are the programming languages I feel most confident with. Additionally, we believe that DevOps is the way to accelerate business, therefore I have some experience with CI / CD tools as well. Finally, I like doing any kind of sports; soccer, judo, and working out at the gym.',
          photo: '/img/adidas-team-sofia/Alvaro_Recuenco.jpg'
        },
        {
          name:'ALBERTO MARTIN',
          position: 'SOFTWARE DEVELOPER ENGINEER, IT',
          info:'As part of Consumer Acquisition team, I work in the Authentication and Authorization area to improve login capabilities. I work with Java, .Net, Web (HTML5, CSS3, JQuery), Web services, SQL Databases. Passionate about football and a hackathon lover, I like learning new technologies and struggling to get the best out of them in search of technical excellence.',
          photo: '/img/adidas-team-sofia/Alberto_Martin.jpg'
        },
        {
          name:'ANA ROIG',
          position: 'SALESFORCE DEVELOPER, IT',
          info:'After my Computer Science studies in Zaragoza, I’ve joined adidas as part of Consumer Service team, working with Salesforce, and am very happy to be part of it. I use mainly Java, Web (HTML5, CSS3, Angular JS), Web Services, Apex, Visualforce, SQL Databases. I like doing sports when I have time, especially running, and going out for some drinks with friends.',
          photo: '/img/adidas-team-sofia/Ana_Roig.jpg'
        },
        {
          name:'CASPER VAN DONDEREN',
          position: 'SENIOR SOFTWARE ENGINEER, IT',
          info:'I am working on customizable products and use different technologies like 3D Technologies, Video Encoding Android, React, React Native, Cloud, Web (HTML / CSS / Node / JS), etc. I am always up for a chat and am interested in cycling and video games.',
          photo: '/img/adidas-team-sofia/Casper_van_Donderen.jpg'
        },
        {
          name:'CONSTANTIN ZWICK',
          position: 'SENIOR MANAGER FUTURE, GLOBAL BRANDS',
          info:'Versatile development engineer with passion for the beautiful game. I previously spent my time on innovative footwear concepts, from ideation, 3D modelling to bringing them to life at Asian development centers. Currently leading interdisciplinary teams in the fields of digital convergence and sensor enabled product, relentlessly aiming to solve the unmet needs of football consumers.',
          photo: '/img/adidas-team-sofia/Constantin_Zwick.jpg'
        },
        {
          name:'TOMEK CIGIELNY',
          position: 'MANAGER FUTURE, GLOBAL BRANDS',
          info:'Industrial engineer with further studies in digital marketing, I have also been close to the start-up ecosystem since my student years. I’ve been working on topics like product innovation, IoT, and IT product development for 4 years now. At adidas I focus on radical innovation, always inspired by the football consumer desires.',
          photo: '/img/adidas-team-sofia/Tomek_Cegielny.jpg'
        }
      ],

      collaborators:[
        {
          collaboratorName: 'Telerik Academy',
          collaboratorLogo: '/img/logo-telerik-academy.png',
          collaboratorLink: 'https://telerikacademy.com/'
        },
        {
          collaboratorName: 'Sofia salesforce dev group',
          collaboratorLogo: '/img/logo-sSofia-sf-group.png',
          collaboratorLink: ''
        },
        {
          collaboratorName: 'Isobar Commerce',
          collaboratorLogo: '/img/Isobar-Commerce-Orange-RGB.png',
          collaboratorLink: ''
        },
        {
          collaboratorName: 'Economic Development via Innovation & Technology',
          collaboratorLogo: '/img/logo-edit.png',
          collaboratorLink: ''
        },
        {
          collaboratorName: 'BCWT',
          collaboratorLogo: '/img/logo-bcwt.png',
          collaboratorLink: ''
        },
        {
          collaboratorName: 'Move.bg',
          collaboratorLogo: '/img/logo-movebg.jpg',
          collaboratorLink: ''
        },
      ],

      locationVideo:[
        {
          videoId: 'DK4UsCqWsuc'
        }
      ],

      photosSlider:[
        {
          imgSlide1:'/img/photos-sofia/slide-1.jpg',
          imgSlide2:'/img/photos-sofia/slide-4.jpg',
          imgSlide3:'/img/photos-sofia/slide-10.jpg',
          imgSlide4:'/img/photos-sofia/slide-12.jpg',
          imgSlide5:'/img/photos-sofia/slide-14.jpg',
          imgSlide6:'/img/photos-sofia/slide-15.jpg',
          imgSlide7:'/img/photos-sofia/slide-16.jpg',
          imgSlide8:'/img/photos-sofia/slide-21.jpg',
          imgSlide9:'/img/photos-sofia/slide-23.jpg',
          imgSlide10:'/img/photos-sofia/slide-25.jpg',
          imgSlide11:'/img/photos-sofia/slide-26.jpg',
          imgSlide12:'/img/photos-sofia/slide-31.jpg',
          imgSlide13:'/img/photos-sofia/slide-32.jpg',
          imgSlide14:'/img/photos-sofia/slide-33.jpg',
          imgSlide15:'/img/photos-sofia/slide-35.jpg',
          imgSlide16:'/img/photos-sofia/slide-36.jpg',
          imgSlide17:'/img/photos-sofia/slide-39.jpg',
          imgSlide18:'/img/photos-sofia/slide-40.jpg',
          imgSlide19:'/img/photos-sofia/slide-45.jpg',
          imgSlide20:'/img/photos-sofia/slide-49.jpg',
          imgSlide21:'/img/photos-sofia/slide-53.jpg',
          imgSlide22:'/img/photos-sofia/slide-55.jpg',
          imgSlide23:'/img/photos-sofia/slide-57.jpg',
          imgSlide24:'/img/photos-sofia/slide-58.jpg',
          imgSlide25:'/img/photos-sofia/slide-59.jpg',
          imgSlide26:'/img/photos-sofia/slide-62.jpg',
          imgSlide27:'/img/photos-sofia/slide-66.jpg',
          imgSlide28:'/img/photos-sofia/slide-77.jpg',
          imgSlide29:'/img/photos-sofia/slide-85.jpg',
          imgSlide30:'/img/photos-sofia/slide-88.jpg',
          imgSlide31:'/img/photos-sofia/slide-90.jpg',
          imgSlide32:'/img/photos-sofia/slide-93.jpg',
          imgSlide33:'/img/photos-sofia/slide-94.jpg',
          imgSlide34:'/img/photos-sofia/slide-95.jpg',
          imgSlide35:'/img/photos-sofia/slide-102.jpg',
          imgSlide36:'/img/photos-sofia/slide-106.jpg',
          imgSlide37:'/img/photos-sofia/slide-107.jpg',
          imgSlide38:'/img/photos-sofia/slide-108.jpg',
          imgSlide39:'/img/photos-sofia/slide-109.jpg',
          imgSlide40:'/img/photos-sofia/slide-112.jpg',
          imgSlide41:'/img/photos-sofia/slide-113.jpg',
          imgSlide42:'/img/photos-sofia/slide-115.jpg',
          imgSlide43:'/img/photos-sofia/slide-117.jpg',
          imgSlide44:'/img/photos-sofia/slide-118.jpg',
          imgSlide45:'/img/photos-sofia/slide-122.jpg',
          imgSlide46:'/img/photos-sofia/slide-123.jpg',
          imgSlide47:'/img/photos-sofia/slide-125.jpg',
          imgSlide48:'/img/photos-sofia/slide-128.jpg',
          imgSlide49:'/img/photos-sofia/slide-130.jpg',
          imgSlide50:'/img/photos-sofia/slide-131.jpg',
          imgSlide51:'/img/photos-sofia/slide-136.jpg',
          imgSlide52:'/img/photos-sofia/slide-141.jpg',
          imgSlide53:'/img/photos-sofia/slide-144.jpg',
          imgSlide54:'/img/photos-sofia/slide-147.jpg',
          imgSlide55:'/img/photos-sofia/slide-148.jpg',
          imgSlide56:'/img/photos-sofia/slide-150.jpg',
          imgSlide57:'/img/photos-sofia/slide-151.jpg',
          imgSlide58:'/img/photos-sofia/slide-156.jpg',
          imgSlide59:'/img/photos-sofia/slide-158.jpg',
          imgSlide60:'/img/photos-sofia/slide-164.jpg',
          imgSlide61:'/img/photos-sofia/slide-165.jpg',
          imgSlide62:'/img/photos-sofia/slide-168.jpg',
          imgSlide63:'/img/photos-sofia/slide-169.jpg',
          imgSlide64:'/img/photos-sofia/slide-170.jpg',
          imgSlide65:'/img/photos-sofia/slide-171.jpg',
          imgSlide66:'/img/photos-sofia/slide-172.jpg',
          imgSlide67:'/img/photos-sofia/slide-173.jpg',
          imgSlide68:'/img/photos-sofia/slide-174.jpg',
          imgSlide69:'/img/photos-sofia/slide-176.jpg',
          imgSlide70:'/img/photos-sofia/slide-178.jpg'

        }
      ],

      program: {
        '12.05': [
          {
            time: '09:00',
            text: 'Registration & welcome bites'
          },
          {
            time: '10:00',
            text: 'Welcome presentation'
          },
          {
            time: '11:00',
            text: 'Team forming, ideation'
          },
          {
            time: '12:00',
            text: 'Hacking & tech trainings'
          },
          {
            time: '13:00',
            text: 'Lunch'
          },
          {
            time: '20:00',
            text: 'Dinner'
          },
          {
            time: '21:00',
            text: 'Continue hacking ...'
          },
        ],

        '13.05': [
          {
            time: '08:00',
            text: 'Breakfast'
          },
          {
            time: '09:00',
            text: 'Hacking'
          },
          {
            time: '13:00',
            text: 'Lunch'
          },
          {
            time: '16:00',
            text: 'Teams project pitches'
          },
          {
            time: '18:00',
            text: 'Winners awards & ceremony'
          },
          {
            time: '20:30',
            text: 'End'
          },

          {
            time: '',
            text: 'Delicious food, drinks, snacks and other refreshments will be served throughout. Tech trainings and additional activities will be announced shortly before and during the event itself.'
          },
        ],
      },
    },


    {
      location: 'Madrid',
      description: "ENABLE SPORT THROUGH TECHNOLOGY",
      date: moment('26/05/2018', 'DD/MM/YYYY'),
      bannerImage: '/img/header-image-3.png',
      bannerImage2: '/img/header-image-4.png',
      locationCoords:{lat: 40.3923033, lng: -3.69743},

      noteDescription:'Tech meets sport to hack the future. Join us to play and explore new experiences using the latest technologies available in the market.',

      fullDescription: '',

      fromToDate: '26-27.05.2018',

      techLibraryDesc: "We will provide you with different technologies that will be announced soon. You will have the chance to learn from the most experienced engineers about different technologies like machine learning, big data and others. Additionally, we will provide you with the APIs and datasets for building your solution. Stay tuned for more info. ",

      techs: [
        {
          name:'Tech 1',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 2',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 3',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 4',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        }
      ],

      venueNameTitle: 'Iron Hack',
      venueName: 'Paseo de la Chopera, 14, 28045 Madrid, Spain',
      mapImage: 'http://www.abc.es/media/espana/2017/10/11/plazaesp-kKrD--620x349@abc.jpg',

      judges: [
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },{
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
      ],
      prizes: 'The winning team from Madrid will qualify for the final at adidas global HQ in Germany where they will compete with the 3 other winners to become the global champion and win exclusive awards. All 4 teams will experience the 3-stripe culture and have the chance to pitch their concept to our senior IT leaders. The winner will receive an exclusive grand prize package. Additionally, there will be prizes for the local winners worth up to 10K in local currency.',

      applicationProcess: 'Apply with your team or alone. adidas will select on rolling basis. The quicker you are, the more chance you have to get in. If you register with a team- you need to add the names of your teammates and they will get an invitation to register. If you join without a team you will have the chance to create your own team, join another one on our platform before or during the hackathon. The ones that get in will receive access to our platform where they can start building their team and brainstorming ideas. Please note – due to the highly international adidas teams & guests, the hackathons will be held mainly in English. We will have people speaking the local language but the presentations and the final prototypes/projects pitches have to be in English.',

      travelReimbursement:'adidas is offering a limited number of travel reimbursements (worth up to 50€ per person) for the first participants to request, coming from somewhere outside of the city where the hackathon is happening. If you get accepted, you need to be quick in applying for reimbursement. In the confirmation e-mail you will receive more information of how to apply. If you win your local hackathon, you will be offered a fully sponsored trip to adidas HQ in Germany. Please check the FAQ for more details.',

      adidasTeam:[
        {
          name:'YONEL ILIEVA',
          position: 'PRODUCT MANAGER',
          info:'My role crosses the intersection where technology meets business. Java, data models, APIs help me bring the business vision into technical capability. Together with my team, we shape the roadmap for our digital product, constantly exploring cutting-edge technologies. I am passionate about AI, data and their utilization in sport &amp; digital products. I love using lunch-time runs and boxing sessions to connect with my colleagues.',
          photo: '/img/adidas-team-madrid/Yonel_Ilieva.jpg'
        },
        {
          name:'FERNANDO CORNAGO',
          position: 'SENIOR DIRECTOR PLATFORM ENGINEERING',
          info:'Passionate team builder, tech lover, agile practitioner, and a rusty coder.  Obsessed with Continuous Improvement, and always looking for the next challenge. For the last 5 months in Platform Engineering designing the platforms and technologies to be used for the adidas agile teams around the globe!',
          photo: '/img/adidas-team-madrid/Fernando_Cornago.jpg'
        },
        {
          name:'STEFANIE SEIDL-WALZ',
          position: 'SENIOR DIRECTOR DIGITAL IT',
          info:'Building kick-ass platforms that facilitate adidas to create the best digital consumer experiences is what pushes my team & myself out of the bed every morning. We are building the foundations of the digital adi-house. I\'m a digital Yogi that never stands still.',
          photo: '/img/adidas-team-madrid/Stefanie_Seidl-Walz.jpg'
        },
        {
          name:'JORGE CHATO',
          position: 'SOFTWARE ENGINEER',
          info:'Born in Spain and bred in the internet. Hacker, free culture, and AI lover. My name is Jorge and coding is the sauce of my life.',
          photo: '/img/adidas-team-madrid/Jorge_Chato.jpg'
        },
        {
          name:'VERONICA TEDJASUKMANA',
          position: 'Solution Architect',
          info:'Passionate about technology, business and usable design. Together with my team, we are bringing a 1-to-1 experiences for our consumers across all digital touchpoints.',
          photo: '/img/adidas-team-madrid/Veronica_Tedjasukmana.jpg'
        },
        {
          name:'DANIEL EICHTEN',
          position: 'SENIOR DIRECTOR PLATFORM ENGINEERING',
          info:'Tinkerer, part-time Nerd, hobby Barista and occasional conference speaker. For the past 20+ years collecting programming languages like Perl, PHP, C/C++, Java, Ruby, Closure, Scala, Javascript, Go, … Since Jan helping adidas in Platform Engineering to become a Cloud Native company.',
          photo: '/img/adidas-team-madrid/Daniel_Eichten.jpg'
        },
        {
          name:'JORGE CÁNCER',
          position: 'INTERN SOFTWARE ENGINEER',
          info:'I\'ve been working to build microservices here at adidas for the past 10 months. I participated in many hackathons before deciding to run my own. I love motorsports, especially Formula 1 and everything about it. I played handball for 3 years.',
          photo: '/img/adidas-team-madrid/Jorge_Cancer.jpg'
        },
        {
          name:'ALEX LATORRE',
          position: 'SOFTWARE DEVELOPER AGILE',
          info:'I\'ve been working with different technologies related to operations and monitoring including scripting in Python and GO and deploying all the required tools. I really like football and support my local team, Real Zaragoza.',
          photo: '/img/adidas-team-madrid/Alex_Latorre.jpg'
        },
        {
          name:'DARIO MARJANOVIC',
          position: 'SENIOR DIRECTOR DOMAIN ARCHITECTURE',
          info:'6 years at adidas and still excited like I just started. I am part of organisation which constantly seek to find new ways of bringing technology into process of adidas product creation. Most of the time I stretch across Component-as-a-service (currently Microservices), API, distributed architectures, Java backend,  Cloud Native app develoment, DevOps, process automation.',
          photo: '/img/adidas-team-madrid/Dario_Marjanovic.jpg'
        },
        {
          name:'JOSE LUIS ALCALA',
          position: 'PLATFORM SOFTWARE ENGINEER',
          info:'I\'ve joined at adidas 2 years ago and I can summarize the journey in one sentence “From mobile to AI”. I\'m a functional programming lover and open source advocate, trying to make the things smarter.',
          photo: '/img/adidas-team-madrid/Jose_Luis_Alcala.jpg'
        },
        {
          name:'JOSE TOMAS RUBIO',
          position: 'ENGINEER MOBILE QA',
          info:'I\'ve been building software for smartphones for more than 15 years. I joined adidas about 5 years ago working mainly in mobile development and QA, both customer face and now internal apps.  Passionate about AI, Security and Cloud computing. The more I learn the more I want to learn.',
          photo: '/img/adidas-team-madrid/Jose_Tomas_Rubio.jpg'
        },
        {
          name:'JAVIER PELAYO',
          position: 'SENIOR PLATFORM ENGINEER',
          info:'4 years already at adidas working on projects related to ecommerce and business monitoring. Streaming and speed serving data is the topic that I focus on currently. Apart from that… metrics, metrics and metrics!',
          photo: '/img/adidas-team-madrid/Javier_Pelayo.jpg'
        },
        {
          name:'LAURA ANDRÉS',
          position: 'TALENT ACQUISTION TRAINEE',
          info:'As part of the Talent Acquisition Team, I’m always seeking talents for the IBERIA market. We redefine our strategy everyday into new innovative ways to bring talented people closer to the adidas culture.',
          photo: '/img/adidas-team-madrid/Laura_Andres.jpg'
        },
        {
          name:'CARLOS GIMENO',
          position: 'DevOps Engineer .com & Mobile Experience',
          info:'A newjoiner to adidas. I\'ve been working for four months at .com & Mobile Experience. A passionate of cloud environments and automation tools. Currently I\'ve spent most of my time orchestrating .com & mobile Experience containers on Kubernetes',
          photo: '/img/adidas-team-madrid/Carlos_Gimeno.jpg'
        }
      ],

      locationVideo:[
        {
          videoId: 'SWhT1KT1L1c'
        }
      ],

      photosSlider:[
        {
          imgSlide1:'/img/photos-madrid/slide-4.jpg',
          imgSlide2:'/img/photos-madrid/slide-5.jpg',
          imgSlide3:'/img/photos-madrid/slide-6.jpg',
          imgSlide4:'/img/photos-madrid/slide-8.jpg',
          imgSlide5:'/img/photos-madrid/slide-10.jpg',
          imgSlide6:'/img/photos-madrid/slide-11.jpg',
          imgSlide7:'/img/photos-madrid/slide-12.jpg',
          imgSlide8:'/img/photos-madrid/slide-13.jpg',
          imgSlide9:'/img/photos-madrid/slide-14.jpg',
          imgSlide10:'/img/photos-madrid/slide-15.jpg',
          imgSlide11:'/img/photos-madrid/slide-16.jpg',
          imgSlide12:'/img/photos-madrid/slide-18.jpg',
          imgSlide13:'/img/photos-madrid/slide-21.jpg',
          imgSlide14:'/img/photos-madrid/slide-23.jpg',
          imgSlide15:'/img/photos-madrid/slide-24.jpg',
          imgSlide16:'/img/photos-madrid/slide-25.jpg',
          imgSlide17:'/img/photos-madrid/slide-29.jpg',
          imgSlide18:'/img/photos-madrid/slide-31.jpg',
          imgSlide19:'/img/photos-madrid/slide-35.jpg',
          imgSlide20:'/img/photos-madrid/slide-36.jpg',
          imgSlide21:'/img/photos-madrid/slide-39.jpg',
          imgSlide22:'/img/photos-madrid/slide-41.jpg',
          imgSlide23:'/img/photos-madrid/slide-42.jpg',
          imgSlide24:'/img/photos-madrid/slide-44.jpg',
          imgSlide25:'/img/photos-madrid/slide-45.jpg',
          imgSlide26:'/img/photos-madrid/slide-46.jpg',
          imgSlide27:'/img/photos-madrid/slide-48.jpg',
          imgSlide28:'/img/photos-madrid/slide-49.jpg',
          imgSlide29:'/img/photos-madrid/slide-50.jpg',
          imgSlide30:'/img/photos-madrid/slide-52.jpg',
          imgSlide31:'/img/photos-madrid/slide-53.jpg',
          imgSlide32:'/img/photos-madrid/slide-57.jpg',
          imgSlide33:'/img/photos-madrid/slide-61.jpg',
          imgSlide34:'/img/photos-madrid/slide-65.jpg',
          imgSlide35:'/img/photos-madrid/slide-66.jpg',
          imgSlide36:'/img/photos-madrid/slide-68.jpg',
          imgSlide37:'/img/photos-madrid/slide-69.jpg',
          imgSlide38:'/img/photos-madrid/slide-70.jpg',
          imgSlide39:'/img/photos-madrid/slide-71.jpg',
          imgSlide40:'/img/photos-madrid/slide-72.jpg',
          imgSlide41:'/img/photos-madrid/slide-75.jpg',
          imgSlide42:'/img/photos-madrid/slide-76.jpg',
          imgSlide43:'/img/photos-madrid/slide-77.jpg',
          imgSlide44:'/img/photos-madrid/slide-79.jpg',
          imgSlide45:'/img/photos-madrid/slide-80.jpg',
          imgSlide46:'/img/photos-madrid/slide-81.jpg',
          imgSlide47:'/img/photos-madrid/slide-85.jpg',
          imgSlide48:'/img/photos-madrid/slide-86.jpg',
          imgSlide49:'/img/photos-madrid/slide-89.jpg',
          imgSlide50:'/img/photos-madrid/slide-90.jpg',
          imgSlide51:'/img/photos-madrid/slide-91.jpg',
          imgSlide52:'/img/photos-madrid/slide-92.jpg',
          imgSlide53:'/img/photos-madrid/slide-93.jpg',
          imgSlide54:'/img/photos-madrid/slide-97.jpg',
          imgSlide55:'/img/photos-madrid/slide-99.jpg',
          imgSlide56:'/img/photos-madrid/slide-100.jpg',
          imgSlide57:'/img/photos-madrid/slide-101.jpg',
          imgSlide58:'/img/photos-madrid/slide-103.jpg',
          imgSlide59:'/img/photos-madrid/slide-104.jpg',
          imgSlide60:'/img/photos-madrid/slide-107.jpg',
          imgSlide61:'/img/photos-madrid/slide-108.jpg',
          imgSlide62:'/img/photos-madrid/slide-109.jpg',
          imgSlide63:'/img/photos-madrid/slide-110.jpg',
          imgSlide64:'/img/photos-madrid/slide-111.jpg',
          imgSlide65:'/img/photos-madrid/slide-113.jpg',
          imgSlide66:'/img/photos-madrid/slide-114.jpg',
          imgSlide67:'/img/photos-madrid/slide-116.jpg',
          imgSlide68:'/img/photos-madrid/slide-120.jpg',
          imgSlide69:'/img/photos-madrid/slide-139.jpg',
          imgSlide70:'/img/photos-madrid/slide-150.jpg'
        }
      ],


      program: {
        '26.05': [
          {
            time: '09:00',
            text: 'Registration & welcome bites'
          },
          {
            time: '10:00',
            text: 'Welcome presentation'
          },
          {
            time: '11:00',
            text: 'Tech trainings and Hacking'
          },
          {
            time: '13:00',
            text: 'Lunch'
          },
          {
            time: '20:30',
            text: 'Dinner & champions league game'
          },
        ],
        '27.05': [
          {
            time: '08:00',
            text: 'Breakfast'
          },
          {
            time: '10:00',
            text: 'Pitch preparation workshop'
          },
          {
            time: '13:00',
            text: 'Lunch'
          },
          {
            time: '16:00',
            text: 'Teams projects pitches'
          },
          {
            time: '18:00',
            text: 'Award ceremony'
          },
          {
            time: '20:00',
            text: 'End'
          },
        ],
      },
    },


    {
      location: 'Amsterdam',
      description: "Personalize the next Gen Shopping Experience",
      date: moment('09/06/2018', 'DD/MM/YYYY'),
      bannerImage: '/img/header-image-5.png',
      bannerImage2: '/img/header-image-6.png',
      locationCoords:{lat: 52.3638197, lng: 4.9067884},

      noteDescription:'Do you have what it takes to get to the finals at adidas HQ in Herzogenaurach on July, the 2nd -July, the 3rd 2018? First step – win your local hackathon!',

      fullDescription: 'Technology, sports, and people are at the core of everything we do. Come and have fun creating a premium, connected, and personalized shopping experience of the future. More details will be announced shortly before and during the hackathon.',

      fromToDate: '09-10.06.2018',

      techLibraryDesc: "We will provide you with different technologies that will be announced soon. You will have the chance to learn from the most experienced engineers about different technologies like machine learning, big data and others. Additionally, we will provide you with the APIs and datasets for building your solution. Stay tuned for more info.",

      techs: [
        {
          name:'Tech 1',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 2',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 3',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        },
        {
          name:'Tech 4',
          avatar: 'http://78.media.tumblr.com/avatar_4e3a771d02d7_128.pnj'
        }
      ],

      venueNameTitle: 'Zoku',
      venueName: 'Weesperstraat 105, 1018 VN Amsterdam, Netherlands',
      mapImage: 'http://www.abc.es/media/espana/2017/10/11/plazaesp-kKrD--620x349@abc.jpg',

      judges: [
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
        {
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },{
          name:'Name Surname',
          position: 'Position @ company',
          avatar: 'http://61designstreet.com/blog/wp-content/uploads/2014/06/lady-cartoon-avatar-illustration.jpg'
        },
      ],

      prizes: 'The winning team from Amsterdam will qualify for the final at adidas global HQ in Germany where they will compete with the 3 other winners to become the global champion and win exclusive awards. All 4 teams will experience the 3-stripe culture and have the chance to pitch their concept to our senior IT leaders. The winner will receive an exclusive grand prize package. Additionally, there will be prizes for the local winners worth up to 10K in local currency.',

      applicationProcess: 'Apply with your team or alone. adidas will select on rolling basis. The quicker you are, the more chance you have to get in. If you register with a team- you need to add the names of your teammates and they will get an invitation to register. If you join without a team you will have the chance to create your own team, join another one on our platform before or during the hackathon. The ones that get in will receive access to our platform where they can start building their team and brainstorming ideas. Please note – due to the highly international adidas teams & guests, the hackathons will be held mainly in English. We will have people speaking the local language but the presentations and the final prototypes/projects pitches have to be in English.',

      travelReimbursement:'adidas is offering a limited number of travel reimbursements (worth up to 50€ per person) for the first participants to request, coming from somewhere outside of the city where the hackathon is happening. If you get accepted, you need to be quick in applying for reimbursement. In the confirmation e-mail you will receive more information of how to apply. If you win your local hackathon, you will be offered a fully sponsored trip to adidas HQ in Germany. Please check the FAQ for more details.',


      adidasTeam:[
        {
          name:'YONEL ILIEVA',
          position: 'PRODUCT MANAGER',
          info:'My role crosses the intersection where technology meets business. Java, data models, APIs help me bring the business vision into technical capability. Together with my team, we shape the roadmap for our digital product, constantly exploring cutting-edge technologies. I am passionate about AI, data and their utilization in sport &amp; digital products. I love using lunch-time runs and boxing sessions to connect with my colleagues.',
          photo: '/img/adidas-team-amsterdam/Yonel_Ilieva.jpg'
        },
        {
          name:'ANTONIO MARTÍNEZ',
          position: 'SOFTWARE DEVELOPER',
          info:'Born and raised in Zaragoza. I automate tasks as much as I can. My interests include data and AI, but while in adidas I\'ve found a new passion - DevOps. My favorite sports are running, skiing, football, and basketball.',
          photo: '/img/adidas-team-amsterdam/Antonio_Martinez.jpg'
        },
        {
          name:'CASPER VAN DONDEREN',
          position: 'SENIOR SOFTWARE ENGINEER',
          info:'I am working on customizable products and use different technologies like 3D Technologies, Video Encoding Android, React, React Native, Cloud, Web (HTML / CSS / Node / JS), etc. I am always up for a chat and am interested in cycling and video games.',
          photo: '/img/adidas-team-amsterdam/Casper_van_Donderen.jpg'
        },
        {
          name:'RASTKO VUKASINOVIC',
          position: 'SENIOR SOLUTION ARHITECT',
          info:'I am working on customizable products and use different technologies like 3D Technologies, Video Encoding Android, React, React Native, Cloud, Web (HTML / CSS / Node / JS), etc. I am always up for a chat and am interested in cycling and video games.',
          photo: '/img/adidas-team-amsterdam/Rastko_Vukasinovic.jpg'
        },
        {
          name:'MOLLY BOYLE',
          position: 'SOFTWARE ENGINEER',
          info:'I have worked for adidas for two years. Until recently, I worked in SEO, keeping up with the latest Google algorithm changes and improving organic search traffic to adidas eCom sites. I moved to front-end development a few months ago, to try my hand at Javascript and React.',
          photo: '/img/adidas-team-amsterdam/Molly_Boyle.jpg'
        },
        {
          name:'ALEX LATORRE',
          position: 'SOFTWARE DEVELOPER AGILE',
          info:'I\'ve been working with different technologies related to operations and monitoring including scripting in Python and GO and deploying all the required tools. I really like football and support my local team, Real Zaragoza.',
          photo: '/img/adidas-team-amsterdam/Alex_Latorre.jpg'
        },
        {
          name:'JORGE CHATO',
          position: 'Software Analyst',
          info:'Born in Spain and bred in The Internet. Hacker, free culture & AI lover. My name is Jorge and coding is the sauce of my life.',
          photo: '/img/adidas-team-amsterdam/Jorge_Chato.jpg'
        },
        {
          name:'JOSE LUIS ALCALA RAMOS',
          position: 'PLATFORM SOFTWARE ENGINEER',
          info:'Two years ago, I joined adidas and I can summarize my journey through one concept: "From mobile to AI."  I\'m a functional programming lover, an open source advocate, and a motivated team leader, striving to make our code as smart as possible.',
          photo: '/img/adidas-team-amsterdam/Jose_Luis_Alcala.jpg'
        },
        {
          name:'ALEJANDRO TORRES',
          position: 'Software Developer Agile',
          info:'My name is Alejandro Torres, I started in adidas as an intern, and after I stayed in Germany as a full time employee. I love to work on proof of concepts, JS, well-crafted user interfaces, new techie stuff, and mountain-biking.',
          photo: '/img/adidas-team-amsterdam/Alejandro_Torres.jpg'
        },
        {
          name:'SIMON DALMACZYNSKI',
          position: 'SENIOR SOFTWARE ENGINEER AGILE',
          info:'I have started my journey at adidas 7 years ago developing prototypes in the innovation team. I have a strong background in mobile development where I was working on apps within the retail space further on. I am leading now the Cloud Native team, where we work on and realize solutions across the latest Cloud Computing technologies.',
          photo: '/img/adidas-team-amsterdam/Simon_Dalmaczynski.jpg'
        },
        {
          name:'ALBERTO SANZ',
          position: 'SOFTWARE DEVELOPER AGILE',
          info:'I’ve been working in adidas the last 6 months as part of the Cloud Native team. I have a strong background on Android mobile development & backend and now I moved to a micro-services architecture approach. Sometimes I even have time to hack the Java compiler.',
          photo: '/img/adidas-team-amsterdam/Alberto_Sanz.jpg'
        },
        {
          name:'IRIS DAGCI',
          position: 'RECRUITER DIGITAL IT, DBC',
          info:'As a recruiter for Digital Brand Commerce and Digital IT based at our HQ in Germany I’m always curious about new digital trends and technologies.',
          photo: '/img/adidas-team-amsterdam/Iris_Dagci.jpg'
        },
        {
          name:'CARMEN JIMÉNEZ',
          position: 'TALENT ACQUISITION',
          info:'I\'m part of the Talent Acquisition Team. I consider myself as a positive, curious, and creative person. Passionate about my job, I always look for the best talent for our IT teams.',
          photo: '/img/adidas-team-amsterdam/Carmen_Jimenez.jpg'
        },
        {
          name:'JAMES LODGE',
          position: 'SENIOR RECRUITER, DIGITAL IT',
          info:'I work in Talent Acquisition, hiring for our Digital IT team here in Amsterdam.',
          photo: '/img/adidas-team-amsterdam/James_Lodge.jpg'
        }

      ],


      program: {
        '09.06': [
          {
            time: '09:00',
            text: 'Registration & welcome bites'
          },
          {
            time: '10:00',
            text: 'Welcome presentation'
          },
          {
            time: '11:00',
            text: 'Tech trainings & hacking'
          },
          {
            time: '13:00',
            text: 'Lunch'
          },
          {
            time: '20:00',
            text: 'Dinner'
          },
        ],
        '10.06': [
          {
            time: '08:00',
            text: 'Breakfast'
          },
          {
            time: '10:00',
            text: 'Pitch preparation workshop'
          },
          {
            time: '13:00',
            text: 'Lunch'
          },
          {
            time: '16:00',
            text: 'Teams projects pitches'
          },
          {
            time: '19:00',
            text: 'Award ceremony'
          },
          {
            time: '20:00',
            text: 'End'
          },
        ],
      },
    },
  ],
  currentChallenge: {},
}

const challenges = (state = initialState , action) => {
  let challenge
  switch (action.type) {
    case 'SET_CURRENT_EVENT':
      challenge = state.data.filter(e => {
        return e.location === action.name
      });
      if(challenge.length){
        return {
          ...state,
          currentChallenge: challenge[0]
        };
      }
      return {...state};
    default:
      return state
  }
}

export default challenges;



// WEBPACK FOOTER //
// ./src/reducers/challenges.js